import React from "react";
import { DataFileModel } from "../api/vehicleFileAPI";
import { Button, ButtonGroup, Col, Row } from "react-bootstrap";
import DateDisplay from "../common/DateDisplay";
import { isViewable } from "../common/fileUtils";

interface DataFileItemProps {
  label?: string;
  file: DataFileModel;
  isDisabled: boolean;
  onView: () => void;
  onDownload: () => void;
  onDelete: () => void;
  onUpdate: () => void;
}

function DataFileItem({
  label,
  file,
  isDisabled,
  onView,
  onDownload,
  onDelete,
  onUpdate,
}: DataFileItemProps) {
  return (
    <Row>
      <Col>
        <div>{label ?? file.filename}</div>
        <small>
          {file.version && `version: ${file.version}, `}
          modified {file.updatedBy && " by " + file.updatedBy} on{" "}
          <DateDisplay date={file.updatedDate} />
        </small>
      </Col>
      <Col className="align-self-center" style={{ textAlign: "right" }}>
        <ButtonGroup size="sm">
          {isViewable(file.filename) && (
            <Button type="button" variant="info" onClick={() => onView()}>
              View
            </Button>
          )}
          <Button type="button" onClick={() => onDownload()}>
            Download
          </Button>
          <Button
            type="button"
            onClick={() => onUpdate()}
            disabled={isDisabled}
          >
            Update
          </Button>
          <Button
            variant="danger"
            type="button"
            disabled={isDisabled}
            onClick={() => {
              if (window.confirm("Are you sure?")) onDelete();
            }}
          >
            Delete
          </Button>
        </ButtonGroup>
      </Col>
    </Row>
  );
}

export default DataFileItem;
